import { useState, useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DashboardLayout } from "@layout/index";
import {
  Home,
  Bookings,
  Claims,
  Vouchers,
  LoginPage,
  NotFound,
  UserManagement,
  ClientManagement,
  ChangePassword,
  ChangeClient,
  CDBalance,
  CDBalancePremium,
} from "@pages/index";
import {
  CircularLoader,
  ErrorBoundary,
  ProtectedRoute,
} from "@components/index";
import "./App.scss";
import "./styles/toast.scss";

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initial page load function
    const initializeApp = async () => {
      setIsLoading(false);
    };

    initializeApp();
  }, []);

  if (isLoading) {
    return (
      <CircularLoader
        message="Loading Data..."
        size="large"
        messageClassName="loaderMesage"
        className="app-loader"
      />
    );
  }

  return (
    <div className="app">
      {/* <Navbar /> */}
      <div className="container">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="*" element={<NotFound reason="route" />} />

            <Route path="/" element={<DashboardLayout />}>
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute requiredPath="/dashboard">
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="bookings"
                element={
                  <ProtectedRoute requiredPath="/bookings">
                    <Bookings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="claims"
                element={
                  <ProtectedRoute requiredPath="/claims">
                    <Claims />
                  </ProtectedRoute>
                }
              />
              <Route
                path="vouchers"
                element={
                  <ProtectedRoute requiredPath="/vouchers">
                    <Vouchers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cd-balance-claims"
                element={
                  <ProtectedRoute requiredPath="/cd-balance-claims">
                    <CDBalance />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cd-balance-premium"
                element={
                  <ProtectedRoute requiredPath="/cd-balance-premium">
                    <CDBalancePremium />
                  </ProtectedRoute>
                }
              />
              <Route
                path="user-management"
                element={
                  <ProtectedRoute requiredPath="/user-management">
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="client-management"
                element={
                  <ProtectedRoute requiredPath="/client-management">
                    <ClientManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="change-password"
                element={
                  <ProtectedRoute requiredPath="/change-password">
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />

              <Route
                path="change-client"
                element={
                  <ProtectedRoute requiredPath="/change-client">
                    <ChangeClient />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </ErrorBoundary>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="app">
      <Router>
        <AppContent />
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
